import superagentPromisePlugin from 'superagent-promise-plugin'

import http_agent from './http_agent'
import http_request from './http_request'
import config from 'config'
import { detectLanguage } from '../helpers/functions'

const language = detectLanguage()

function _genericCatch() {
	return {
		error_code: -1,
		payload: {
			message: 'Something went wrong. Please try again later.',
		},
	}
}

function getUserData() {
	return http_request.post(config.services + 'service.php')
		.send({
			method: 'userLogged',
			language,
		})
}

function getUserExtraData(environment) {
	return http_request.post(config.services + 'user/getExtra')
		.send({
			environment,
		})
}

function getComplementaryData(userId) {
	return http_request.post(config.services + 'service.php')
		.send({
			method: 'getComplementaryData',
			language: 'en',
			userId,
			type: 'ios',
		})
}

function getUserMyAccountData() {
	return http_agent.post(config.services + 'user/get')
		.send({})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			response = JSON.parse(response.text)
			return response
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function updateTooltip(tooltipName) {
	return http_agent.post(config.services + 'user/saveTooltip')
		.send({
			tooltip: tooltipName,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function savePersonalInfo(firstName, lastName, email, password) {
	return http_agent.post(config.services + 'user/savePersonalInfo')
		.send({
			firstName,
			lastName,
			email,
			password,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function changePassword(oldPassword, newPassword, newPasswordRepeat) {
	return http_request.post(config.services + 'user/changePassword')
		.send({
			oldPassword,
			newPassword,
			newPasswordRepeat,
		})
}

function saveSchoolInfo(countryId, stateId, institutionId, institutionName, city) {
	return http_agent.post(config.services + 'user/saveSchoolInfo')
		.send({
			countryId,
			stateId,
			city,
			institutionId,
			institutionName,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function saveTeacherInfo(gradeIds, subjectIds) {
	const params = {}
	if (gradeIds) {
		params.gradeIds = gradeIds
	}
	if (subjectIds) {
		params.subjectIds = subjectIds
	}
	return http_agent.post(config.services + 'user/saveTeacherInfo')
		.send(params)
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function sendHelp(text, title) {
	return http_agent.post(config.services + 'user/sendFeedback')
		.send({
			text,
			title,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function saveOnboardingQuestion(question, answer) {
	return http_agent.post(config.services + 'user/saveOnboardingQuestion')
		.send({
			q: question,
			a: answer,
		})
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			response = JSON.parse(response.text)
			return response
		})
		.catch(err => {
			_genericCatch(err)
		})
}

function trackUserAction(params) {
	return http_request.post(config.ct + 'service/user/trackAction.php')
		.send(params)
}

function loginNotification(overlayType, buttonUserType, actionUserType, presentationId) {
	return http_request.post(config.ct + 'service/user/loginNotification.php')
		.send({
			featureType: overlayType,
			button: buttonUserType,
			action: actionUserType,
			presentationId,
		})
}

function saveUserAccountInformation(schoolId, roleId, gradeIds, subjectIds) {
	return http_request.post(`${config.api}users/account`)
		.send({
			institutionId: schoolId,
			roleId,
			gradeIds,
			subjectIds,
		})
}

function setTestCookie() {
	return http_request.post(`${config.api}cookies/test`)
		.send({})
}

function getTestCookie() {
	return http_request.get(`${config.api}cookies/test`)
		.send({})
}

function acceptTermsAndConditions() {
	return http_request.post(config.services + 'user/acceptTermsAndConditions')
		.send({})
}

function getPermissions() {
	return http_request.get(`${config.api}users/permissions`)
		.send({})
}

export default {
	getUserData,
	getUserExtraData,
	getUserMyAccountData,
	updateTooltip,
	savePersonalInfo,
	changePassword,
	saveSchoolInfo,
	saveTeacherInfo,
	sendHelp,
	saveOnboardingQuestion,
	getComplementaryData,
	trackUserAction,
	loginNotification,
	saveUserAccountInformation,
	setTestCookie,
	getTestCookie,
	acceptTermsAndConditions,
	getPermissions,
}
